const state = {
    showVerticalMenu: true,

    counters: {},
    showCounters: false,
    OwnTaskCountersAreSet: false,
    DelegatedTaskCountersAreSet: false,
    accountingFirmUser: null,

    viewAllTodos: false,

    menuRoutes: '',
}

const mutations = {
    RESET(state) {
        state.test = null
    },

    SET_IS_ADMIN(state, viewAllTodos) {
        state.viewAllTodos = viewAllTodos
    },

    SET_OWN_TASKS_COUNTERS(state) {
        state.OwnTaskCountersAreSet = true
    },

    RESET_OWN_TASKS_COUNTERS(state) {
        state.OwnTaskCountersAreSet = false
    },

    SET_DELEGATED_TASKS_COUNTERS(state) {
        state.DelegatedTaskCountersAreSet = true
    },

    RESET_DELEGATED_TASKS_COUNTERS(state) {
        state.DelegatedTaskCountersAreSet = false
    },

    SET_COUNTER(state, [data, type]) {
        state.counters[type] = data
    },

    SHOW_COUNTERS(state) {
        state.showCounters = true
    },

    HIDE_COUNTERS(state) {
        state.showCounters = false
    },

    SET_MENU_ROUTES(state, menuRoutes) {
        state.menuRoutes = menuRoutes
    },

    SHOW_VERTICAL_MENU(state) {
        state.showVerticalMenu = true
    },

    HIDE_VERTICAL_MENU(state) {
        state.showVerticalMenu = false
    },

    SET_ACCOUNTING_FIRM_USER_OPTION(state, accountingFirmUser) {
        state.accountingFirmUser = accountingFirmUser
    },
}

const actions = {
    async getCounter({ commit }, type) {
        try {
            const response = await axios.get(`/reporting/counter/${type}`)
            commit('SET_COUNTER', [response.data, type])
            if (type === 'ownTasks') {
                commit('SET_OWN_TASKS_COUNTERS')
            }
            if (type === 'delegatedTasks') {
                commit('SET_DELEGATED_TASKS_COUNTERS')
            }
        } catch (error) {
            console.log(`counter ${type}not loaded`)
        }
    },

    async refreshCounters({ dispatch }) {
        dispatch('getCounter', 'ownTasks')
        dispatch('getCounter', 'delegatedTasks')
    },

    async getRoutes({ commit }) {
        try {
            const response = await axios.get('/todo/routes')
            commit('SET_MENU_ROUTES', response.data)
        } catch (error) {
            // console.log(error)
            console.log('menuRoutes not loaded')
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
